(function() { module.exports = this["NeoGames"]; }());


/*****************
 ** WEBPACK FOOTER
 ** external "NeoGames"
 ** module id = 3
 ** module chunks = 0
 **/